import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2, AdminNavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { incentiveBudgetsAdminRouter } from './routing/incentiveBudgetsAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { incentiveBudgetsViewAccessControl } from './access-control/incentiveBudgetsAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'incentive-budgets',
  totem: {
    tool: 'incentive-budgets-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {},
  routers: {
    admin: [incentiveBudgetsAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Operations,
      attachToV3: AdminNavEntryPointV3.Fulfillment,
      subNavItems: [
        {
          route: 'app-admin-incentive-budgets-list',
          labelId: 'incentiveBudgetsDomain.nav.label',
          labelIdV3: 'incentiveBudgetsDomain.nav.label.v3',
          accessControl: incentiveBudgetsViewAccessControl,
        },
        {
          route: 'app-admin-incentive-budgets-events',
          labelId: 'incentiveBudgetsDomain.nav.events.label',
          labelIdV3: 'incentiveBudgetsDomain.nav.events.label.v3',
          accessControl: incentiveBudgetsViewAccessControl,
        },
      ],
    },
  ],
}

export default definition
